"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAdvancedViewerFilter = exports.clearSelectedProducts = exports.setSelectedProducts = exports.addSelectedProductIds = exports.addSelectedProductId = exports.setIsExclusionModeOn = exports.productsSetExcludedTaxonomyClassIds = exports.clearNotExistTaxonomyClasses = exports.productsSetIncludedTaxonomyClassIds = exports.productsSetExcludedAttributesIds = exports.productsSetIncludedAttributesIds = exports.productsSetExcludedCategoriesIds = exports.productsSetIncludedCategoriesIds = exports.productsSetFilterOperator = exports.productsSetFilterActive = exports.DEFAULT_STATE = void 0;
const ramda_1 = require("ramda");
const Actions = __importStar(require("../actions/types"));
const State = __importStar(require("../state"));
const DEFAULT_ADVANCED_FILTER = {
    field: null,
    operator: null,
    value: '',
    connector: null,
};
exports.DEFAULT_STATE = {
    productFilterActive: State.ProductFilterActiveTypes.All,
    productFilterResults: State.ProductFilterOperatorType.Or,
    includedCategoriesIds: [],
    excludedCategoriesIds: [],
    includedAttributesIds: [],
    excludedAttributesIds: [],
    includedTaxonomyClassIds: [],
    excludedTaxonomyClassIds: [],
    data: null,
    isExclusionModeOn: false,
    selectedProductIds: [],
    total: 0,
    advancedViewerFilterData: [DEFAULT_ADVANCED_FILTER],
};
const productsSetFilterActive = (state, { payload: data }) => (Object.assign(Object.assign({}, state), { productFilterActive: data.type }));
exports.productsSetFilterActive = productsSetFilterActive;
const productsSetFilterOperator = (state, { payload: data }) => (Object.assign(Object.assign({}, state), { productFilterResults: data.type }));
exports.productsSetFilterOperator = productsSetFilterOperator;
const productsSetIncludedCategoriesIds = (state, includedCategoriesIds) => (Object.assign(Object.assign({}, state), { includedCategoriesIds, excludedCategoriesIds: (0, ramda_1.without)(includedCategoriesIds, state.excludedCategoriesIds) }));
exports.productsSetIncludedCategoriesIds = productsSetIncludedCategoriesIds;
const productsSetExcludedCategoriesIds = (state, excludedCategoriesIds) => (Object.assign(Object.assign({}, state), { excludedCategoriesIds, includedCategoriesIds: (0, ramda_1.without)(excludedCategoriesIds, state.includedCategoriesIds) }));
exports.productsSetExcludedCategoriesIds = productsSetExcludedCategoriesIds;
const productsSetIncludedAttributesIds = (state, includedAttributesIds) => (Object.assign(Object.assign({}, state), { includedAttributesIds: (0, ramda_1.uniqWith)((a, b) => a.startsWith(b), includedAttributesIds.sort()), excludedAttributesIds: state.excludedAttributesIds.filter((excludedId) => !includedAttributesIds.some((includedId) => excludedId.startsWith(includedId))) }));
exports.productsSetIncludedAttributesIds = productsSetIncludedAttributesIds;
const productsSetExcludedAttributesIds = (state, excludedAttributesIds) => (Object.assign(Object.assign({}, state), { excludedAttributesIds: (0, ramda_1.uniqWith)((a, b) => a.startsWith(b), excludedAttributesIds.sort()), includedAttributesIds: state.includedAttributesIds.filter((includedId) => !excludedAttributesIds.some((excludedId) => includedId.startsWith(excludedId))) }));
exports.productsSetExcludedAttributesIds = productsSetExcludedAttributesIds;
const productsSetIncludedTaxonomyClassIds = (state, { payload: { id } }) => {
    const { excludedTaxonomyClassIds, includedTaxonomyClassIds } = state;
    const includedIds = includedTaxonomyClassIds.includes(id)
        ? (0, ramda_1.without)([id], includedTaxonomyClassIds)
        : [...includedTaxonomyClassIds, id];
    return Object.assign(Object.assign({}, state), { includedTaxonomyClassIds: includedIds, excludedTaxonomyClassIds: (0, ramda_1.without)(includedIds, excludedTaxonomyClassIds) });
};
exports.productsSetIncludedTaxonomyClassIds = productsSetIncludedTaxonomyClassIds;
const clearNotExistTaxonomyClasses = (state, { payload: { ids } }) => {
    const { includedTaxonomyClassIds } = state;
    return (Object.assign(Object.assign({}, state), { includedTaxonomyClassIds: includedTaxonomyClassIds.filter((elem) => !ids.includes(elem)) }));
};
exports.clearNotExistTaxonomyClasses = clearNotExistTaxonomyClasses;
const productsSetExcludedTaxonomyClassIds = (state, { payload: { id } }) => {
    const { excludedTaxonomyClassIds, includedTaxonomyClassIds } = state;
    const excludedIds = excludedTaxonomyClassIds.includes(id)
        ? (0, ramda_1.without)([id], excludedTaxonomyClassIds)
        : [...excludedTaxonomyClassIds, id];
    return Object.assign(Object.assign({}, state), { excludedTaxonomyClassIds: excludedIds, includedTaxonomyClassIds: (0, ramda_1.without)(excludedIds, includedTaxonomyClassIds) });
};
exports.productsSetExcludedTaxonomyClassIds = productsSetExcludedTaxonomyClassIds;
const setIsExclusionModeOn = (state, { payload: { isExclusionModeOn } }) => (Object.assign(Object.assign({}, state), { isExclusionModeOn }));
exports.setIsExclusionModeOn = setIsExclusionModeOn;
const addSelectedProductId = (state, { payload: { id } }) => {
    const { selectedProductIds } = state;
    const index = selectedProductIds.findIndex((item) => item === id);
    if (index < 0) {
        return Object.assign(Object.assign({}, state), { selectedProductIds: [...selectedProductIds, id] });
    }
    return Object.assign(Object.assign({}, state), { selectedProductIds: selectedProductIds.filter((item) => item !== id) });
};
exports.addSelectedProductId = addSelectedProductId;
const addSelectedProductIds = (state, { payload: { ids } }) => {
    const { selectedProductIds } = state;
    const result = [...selectedProductIds];
    ids.forEach((item) => {
        if (!result.includes(item)) {
            result.push(item);
        }
    });
    return Object.assign(Object.assign({}, state), { selectedProductIds: result });
};
exports.addSelectedProductIds = addSelectedProductIds;
const setSelectedProducts = (state, { payload: { ids } }) => {
    const selectedProductIds = (0, ramda_1.uniq)([...state.selectedProductIds, ...ids]);
    return Object.assign(Object.assign({}, state), { selectedProductIds });
};
exports.setSelectedProducts = setSelectedProducts;
const clearSelectedProducts = (state, { payload: { ids } }) => (Object.assign(Object.assign({}, state), { selectedProductIds: state.selectedProductIds.filter((item) => !ids.includes(item)) }));
exports.clearSelectedProducts = clearSelectedProducts;
const setAdvancedViewerFilter = (state, { payload: { filter } }) => (Object.assign(Object.assign({}, state), { advancedViewerFilterData: filter }));
exports.setAdvancedViewerFilter = setAdvancedViewerFilter;
// eslint-disable-next-line complexity
exports.default = (state = exports.DEFAULT_STATE, action) => {
    switch (action.type) {
        case Actions.PRODUCTS_SET_FILTER_ACTIVE:
            return (0, exports.productsSetFilterActive)(state, action);
        case Actions.PRODUCTS_SET_FILTER_OPERATOR:
            return (0, exports.productsSetFilterOperator)(state, action);
        case Actions.PRODUCTS_SET_INCLUDED_CATEGORIES_IDS:
            return (0, exports.productsSetIncludedCategoriesIds)(state, action.payload.includedCategoriesIds);
        case Actions.PRODUCTS_SET_EXCLUDED_CATEGORIES_IDS:
            return (0, exports.productsSetExcludedCategoriesIds)(state, action.payload.excludedCategoriesIds);
        case Actions.PRODUCTS_SET_INCLUDED_ATTRIBUTES_IDS:
            return (0, exports.productsSetIncludedAttributesIds)(state, action.payload.includedAttributesIds);
        case Actions.PRODUCTS_SET_EXCLUDED_ATTRIBUTES_IDS:
            return (0, exports.productsSetExcludedAttributesIds)(state, action.payload.excludedAttributesIds);
        case Actions.PRODUCTS_SET_INCLUDED_TAXONOMY_CLASS_IDS:
            return (0, exports.productsSetIncludedTaxonomyClassIds)(state, action);
        case Actions.CLEAR_NOT_EXIST_TAXONOMY_CLASSES:
            return (0, exports.clearNotExistTaxonomyClasses)(state, action);
        case Actions.PRODUCTS_SET_EXCLUDED_TAXONOMY_CLASS_IDS:
            return (0, exports.productsSetExcludedTaxonomyClassIds)(state, action);
        case Actions.PRODUCTS_CLEAR_EXCLUDED_TAXONOMY_CLASS_IDS:
            return Object.assign(Object.assign({}, state), { excludedTaxonomyClassIds: [] });
        case Actions.PRODUCTS_CLEAR_INCLUDED_TAXONOMY_CLASS_IDS:
            return Object.assign(Object.assign({}, state), { includedTaxonomyClassIds: [] });
        case Actions.PRODUCTS_SET_IS_EXCLUSION_MODE_ON:
            return (0, exports.setIsExclusionModeOn)(state, action);
        case Actions.PRODUCTS_ADD_SELECTED_ID:
            return (0, exports.addSelectedProductId)(state, action);
        case Actions.PRODUCTS_ADD_SELECTED_IDS:
            return (0, exports.addSelectedProductIds)(state, action);
        case Actions.PRODUCTS_SET_SELECTED:
            return (0, exports.setSelectedProducts)(state, action);
        case Actions.PRODUCTS_CLEAR_SELECTED:
            return (0, exports.clearSelectedProducts)(state, action);
        case Actions.PRODUCTS_CLEAR_ALL_SELECTED:
            return Object.assign(Object.assign({}, state), { selectedProductIds: [] });
        case Actions.PRODUCTS_SET_TOTAL:
            return Object.assign(Object.assign({}, state), { total: action.payload.total });
        case Actions.PRODUCTS_SET_ADVANCED_VIEWER_FILTER:
            return (0, exports.setAdvancedViewerFilter)(state, action);
        case Actions.RESET:
            return exports.DEFAULT_STATE;
        default:
            return state;
    }
};
